import { CHAIN_EXPLORER_URL_BIFROST as SDK_CHAIN_EXPLORER_URL_BIFROST } from '@bifrost-platform/bifront-sdk-react-biholder';

// explorer url
export const MAINNET_CHAIN_EXPLORER_URL_BIFROST =
  SDK_CHAIN_EXPLORER_URL_BIFROST;
export const MAINNET_CHAIN_EXPLORER_URL_ETHEREUM = 'https://etherscan.io/';
export const MAINNET_CHAIN_EXPLORER_URL_ARBITRUM = 'https://arbiscan.io/';
export const MAINNET_CHAIN_EXPLORER_URL_POLYGON = 'https://polygonscan.com/';
export const MAINNET_CHAIN_EXPLORER_URL_BSC = 'https://bscscan.com/';
export const MAINNET_CHAIN_EXPLORER_URL_BASE = 'https://basescan.org/';
export const MAINNET_CHAIN_EXPLORER_URL_CORE = 'https://scan.coredao.org/';

export const MAINNET_CHAIN_EXPLORER_URLS = [
  MAINNET_CHAIN_EXPLORER_URL_BIFROST,
  MAINNET_CHAIN_EXPLORER_URL_ETHEREUM,
  MAINNET_CHAIN_EXPLORER_URL_ARBITRUM,
  MAINNET_CHAIN_EXPLORER_URL_POLYGON,
  MAINNET_CHAIN_EXPLORER_URL_BSC,
  MAINNET_CHAIN_EXPLORER_URL_BASE,
  MAINNET_CHAIN_EXPLORER_URL_CORE,
];
